import { useState } from "react";
import Grid from "@mui/material/Grid";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import ClearIcon from "@mui/icons-material/Clear";
import { useUserChats } from "../contexts/UserChatsContext";
import SearchIcon from "@mui/icons-material/Search";

function SearchBar() {
  const { searchQuery, setSearchQuery } = useUserChats();
  const [inputValue, setInputValue] = useState(searchQuery);

  const handleSearch = () => {
    setSearchQuery(inputValue);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
      e.target.blur();
    }
  };

  const handleClear = () => {
    setInputValue("");
    setSearchQuery("");
  };

  return (
    <Grid item xs={12} lg={3} sx={{ mt: 2 }}>
      <MKTypography display="block" variant="button" fontWeight="regular" color="text" mb={0}>
        Zoeken
      </MKTypography>
      <MKInput
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        type="text"
        variant="standard"
        fullWidth
        sx={{
          height: "2.5rem",
          fontSize: "0.875rem",
          padding: "0.5rem 0",
          "& .MuiInput-root": {
            height: "2.5rem",
            fontSize: "0.875rem",
            padding: "0.5rem 0",
          },
        }}
        InputProps={{
          endAdornment: inputValue ? (
            <InputAdornment position="end">
              <IconButton aria-label="clear search" onClick={handleClear} edge="end" size="small">
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : (
            <InputAdornment position="end">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  );
}

export default SearchBar;
